import { useConsumerInstallInfoConfig } from '@office-start/consumer-install-service';
import { useWorkloadPublicData } from '@office-start/workload-publicdata-config-service';
import { useMemo } from 'react';
import { getIsSubscribedUser } from './../util';
export var useIsSubscribedUser = function () {
    var consumerInstallConfig = useConsumerInstallInfoConfig().data;
    var workloadPublicDataConfig = useWorkloadPublicData().data;
    return useMemo(function () {
        return getIsSubscribedUser({
            consumerInstallConfig: consumerInstallConfig,
            workloadPublicDataConfig: workloadPublicDataConfig,
        });
    }, [consumerInstallConfig, workloadPublicDataConfig]);
};
//# sourceMappingURL=useIsSubscribedUser.js.map